module.exports = __webpack_public_path__ + "static/media/medalha_3.43e47dbd.svg";